
<template>
  <div class="totalBox">
    <div class="countBox">
      <span><span>电脑vr: </span> <span>{{countData.pcVrCount}}</span></span>
      <span><span>Meta Quest:</span>  <span>{{countData.metaCount}}</span></span>
      <span><span>电脑单机:</span> <span>{{ countData.pcCount }}</span></span>
      <span><span>switch游戏: </span><span>{{countData.switchNum}}</span></span>
      <span><span>PS4游戏: </span><span>{{countData.ps4Count}}</span></span>
      <span><span>PSVR游戏: </span><span>{{ countData.psVrCount }}</span></span>
      <span><span>工具软件:</span> <span>{{ countData.toolCount }}</span></span>
      <span><span>教程攻略:</span> <span>{{ countData.jiaochengCount }}</span></span>
    </div>
    <myHeader ref="header" @setGameList="setGameList" @setLastSearchType="setLastSearchType"></myHeader>
    <div style="border-radius: 4px;box-sizing:border-box;text-align: left;width: 80%;margin: auto;background-color: #2c3e50;color: #fff;line-height: 36px;padding-left: 10px;box-sizing: border-box;">
      <header1 ref="header1" @selectOption="selectOption"></header1>
    </div>
  </div>

</template>
<script>

import myHeader from "@/components/qt/header.vue";
import header1 from "@/components/qt/header1.vue";
import {getGameCount} from "@/api/qt/common";
export default {
  name:"headerTotal",
  props:['selectOptionP','setGameListP','setLastSearchTypeP'],
  components:{
    myHeader,
    header1,
  },
  data(){
    return {
      countData:[]
    }
  },
  created() {
    this.getGameCountMy()
  },
  methods:{
    setLastSearchType(){
      this.$emit('setLastSearchType',...arguments);
    },
    selectOption(){
      this.$emit("selectOptionP",...arguments);
    },
    setGameList(){
      this.$emit("setGameListP",...arguments)
    },
    getGameCountMy(){
      console.log('2234');
      getGameCount().then(res=>{
        this.countData = res.data.data;
        console.log(this.countData,'2234');
      })
    },
  }
}
</script>

<style scoped>

.kf{

  border-radius: 10px;
  position: fixed;
  right:0px;
  bottom:calc(50vh - 20px);
  text-align: center;
  color: #fff;
  background-color: #2c3e50;
  padding: 9px 5px;
  display: inline-block;
}
.countBox > span{
  width: 100%;
  color:#fff;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
}
.countBox{
  width:9%;
  border-radius: 4px;
  position: absolute;
  left:0.5%;
  background-color: #2c3e50;
  top:71px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  box-sizing: border-box;
  font-size: 12px;
}
</style>
